<template>
    <div v-if="pendingInvitations.length > 0" class="pending-invitations">
        <div class="section-title">
            {{ $t('student.you_have_pending_invitations') }}
        </div>

        <student-invitation-card :invitation="lastInvitation"/>

        <go-to v-if="hasMoreInvitations" class="mt-0" :name="$t('common.see_all')" :to="{name: 'student.invitations'}"/>
    </div>
</template>

<script>
import StudentInvitationCard from "@/components/common/cards/StudentInvitationCard";
import {mapState} from "vuex";
import GoTo from "@/components/elements/buttons/goTo";

export default {
    name: "PendingInvitations",
    components: {GoTo, StudentInvitationCard},
    computed: {
        ...mapState(['studentInvitations']),
        pendingInvitations(vm = this) {
            return vm.studentInvitations.filter(invitation => invitation.status === 'pending')
        },
        hasMoreInvitations(vm = this) {
            return vm.pendingInvitations.length > 1
        },
        lastInvitation(vm = this) {
            return vm.pendingInvitations[0]
        }
    }
}
</script>

<style scoped>

.pending-invitations {
    display: flex;
    flex-direction: column;
}

.section-title {
    font-size: 12px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 10px;
}

</style>